import React from "react";

export default function SectionHeader({ eyebrow, title, description, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <span className="label-eyebrow">— {eyebrow}</span>}
      <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-heading font-semibold tracking-tight text-ink text-balance leading-[1.1]">
        {title}
      </h2>
      {description && <p className="mt-5 text-base sm:text-lg text-ink/65 leading-relaxed text-pretty">{description}</p>}
    </div>
  );
}
